__turbopack_context__.v({
  "arrowBadge": "tuge6q_arrowBadge",
  "body": "tuge6q_body",
  "bodyInner": "tuge6q_bodyInner",
  "count": "tuge6q_count",
  "eyebrow": "tuge6q_eyebrow",
  "footerRule": "tuge6q_footerRule",
  "glass": "tuge6q_glass",
  "h1": "tuge6q_h1",
  "hero": "tuge6q_hero",
  "heroFrame": "tuge6q_heroFrame",
  "heroInner": "tuge6q_heroInner",
  "heroScrim": "tuge6q_heroScrim",
  "heroShader": "tuge6q_heroShader",
  "hint": "tuge6q_hint",
  "lede": "tuge6q_lede",
  "list": "tuge6q_list",
  "page": "tuge6q_page",
  "phrase": "tuge6q_phrase",
  "row": "tuge6q_row",
  "rowBlurb": "tuge6q_rowBlurb",
  "rowHead": "tuge6q_rowHead",
  "rowIcon": "tuge6q_rowIcon",
  "rowName": "tuge6q_rowName",
  "rowText": "tuge6q_rowText",
  "searchPill": "tuge6q_searchPill",
  "sectionLabel": "tuge6q_sectionLabel",
});
